var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu24Dp434343Fill0Wght400Grad0Opsz48 = function SvgMenu24Dp434343Fill0Wght400Grad0Opsz48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#434343",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-240v-60h720v60zm0-210v-60h720v60zm0-210v-60h720v60z"
  })));
};
export default SvgMenu24Dp434343Fill0Wght400Grad0Opsz48;